import React from "react";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField'
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns"

import RenderError from '../render-error'

interface DayPassProps {
  [key: string]: any
}

const DayPass: React.FC<DayPassProps> = (props: any) => {

  function handleDateChange(date: any) {
    props.setFieldValue('previous_visit_date', date)
  }

  function handleBlur(field: string, val: string) {
    if (field === 'previous_visit_ticket_number') {
      props.setFieldValue(field, val.trim())
    }
  }

  return (
    <>
      <div className="row">
        <div id="special-discount" className="clearfix box">
          <div className="large-12 columns">
            <h2>Your discount</h2>
            <p>It’s easy to claim your discount of £20 off the price of your first year of membership – simply complete the following details. Please note, this discount is only valid if you hold an adult day ticket for Kew Gardens for a visit within the last month. This discount can only be used once.</p>
          </div>
          <div className="medium-12 columns ticket-purchased">
            <label><strong>Where did you buy your ticket?</strong></label>
            <fieldset>
              <legend>Ticket details</legend>
              <div className="radios">
                <FormControl component="fieldset">
                  <RadioGroup row name="ticketPurchasedAt" value={props.values.ticketPurchasedAt} onChange={props.handleChange}>
                    <FormControlLabel value="kew" control={<Radio color="secondary" />} label="In person at Kew Gardens" checked={props.values.ticketPurchasedAt === 'kew'} />
                    <FormControlLabel value="online" control={<Radio color="secondary" />} label="Online" checked={props.values.ticketPurchasedAt === 'online'} />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="medium-6 columns clear">
                <div className="input-container">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      name="previous_visit_date"
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      label="Date of visit"
                      format="dd/MM/yyyy"
                      disableFuture
                      maxDate={new Date()}
                      minDate={new Date(new Date().setDate(new Date().getDate() - 31))}
                      inputProps={{
                        "aria-describedby": "previous_visit_date_error"
                      }}
                      error={props.errors.previous_visit_date ? true : false}
                      value={props.values.previous_visit_date || null}
                      // onChange={props.handleChange}
                      onChange={(date) => handleDateChange(date)}
                    />
                  </MuiPickersUtilsProvider>
                  <RenderError name="previous_visit_date" id="previous_visit_date_error" {...props} />
                </div>
                <div id="pika-container"></div>
              </div>
              <div className="medium-6 columns">
                <div className="input-container">
                  <TextField
                    type="text"
                    variant="outlined"
                    id="ticket-reference-number"
                    name="previous_visit_ticket_number"
                    label={`${props.values.ticketPurchasedAt === 'kew' ? 'Transaction number' : 'Ticket reference number'}`}
                    inputProps={{
                      "aria-describedby": "ticket-reference-number_error"
                    }}
                    error={props.errors.previous_visit_ticket_number ? true : false}
                    value={props.values.previous_visit_ticket_number}
                    onChange={props.handleChange}
                    onBlur={(e) => handleBlur('previous_visit_ticket_number', e.target.value)} />
                  <RenderError name="previous_visit_ticket_number" id="ticket-reference-number_error" {...props} />
                  <div className="spacer"></div>
                  <div className="help">
                    { props.values.ticketPurchasedAt === 'kew' &&
                      <p>Your ticket transaction number is the five-digit code in the bottom right of your ticket</p>
                    }
                    { props.values.ticketPurchasedAt === 'online' &&
                      <p>Your ticket reference number is the eight or nine-digit code in the bottom right of your ticket</p>
                    }
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="large-12 columns">
            <p className="info">Not a recent visitor to Kew Gardens? You can <a href="https://www.kew.org/join-and-support/become-a-member-kew">sign up as a member here</a> instead.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DayPass;